import DepositCashScreen from 'features/moveMoney/screens/depositCash/DepositCashScreen';
import React from 'react';

export default function Page() {
  return <DepositCashScreen />;
}
